export default __webpack_public_path__ + "static/qr-shop-tianmao-0ac39d3595b6b2efa454dc8bca56f0f1.jpg";